import React, { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

const CartProvider = ({ children }) => {
  // Initialize states with values from localStorage or default values
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });
  const [itemAmount, setItemAmount] = useState(() => {
    const savedItemAmount = localStorage.getItem("itemAmount");
    return savedItemAmount ? JSON.parse(savedItemAmount) : 0;
  });
  const [total, setTotal] = useState(() => {
    const savedTotal = localStorage.getItem("total");
    return savedTotal ? JSON.parse(savedTotal) : 0;
  });
  const [taxRate, setTaxRate] = useState(() => {
    const savedTaxRate = localStorage.getItem("taxRate");
    return savedTaxRate ? JSON.parse(savedTaxRate) : 0.0;
  });
  const [shippingCost, setShippingCost] = useState(() => {
    const savedShippingCost = localStorage.getItem("shippingCost");
    return savedShippingCost ? JSON.parse(savedShippingCost) : 0.0;
  });

  // Sync state with localStorage
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    localStorage.setItem("itemAmount", JSON.stringify(itemAmount));
  }, [itemAmount]);

  useEffect(() => {
    localStorage.setItem("total", JSON.stringify(total));
  }, [total]);

  useEffect(() => {
    localStorage.setItem("taxRate", JSON.stringify(taxRate));
  }, [taxRate]);

  useEffect(() => {
    localStorage.setItem("shippingCost", JSON.stringify(shippingCost));
  }, [shippingCost]);

  useEffect(() => {
    const total = cart.reduce((accumulator, currentItem) => {
      return accumulator + currentItem.price * currentItem.amount;
    }, 0);
    setTotal(total);
  }, [cart]);

  useEffect(() => {
    if (cart) {
      const amount = cart.reduce((accumulator, currentItem) => {
        return accumulator + currentItem.amount;
      }, 0);
      setItemAmount(amount);
    }
  }, [cart]);

  const addToCart = (product, id) => {
    const newItem = { ...product, amount: 1 };
    const cartItem = cart.find((item) => item.id === id);
    if (cartItem) {
      const newCart = cart.map((item) => {
        if (item.id === id) {
          return { ...item, amount: cartItem.amount + 1 };
        } else return item;
      });
      setCart(newCart);
    } else {
      setCart([...cart, newItem]);
    }
  };

  const removeFromCart = (id) => {
    const newCart = cart.filter((item) => item.id !== id);
    setCart(newCart);
  };

  const clearCart = () => {
    setCart([]);
    setTaxRate(0.0);
    setShippingCost(0.0);
  };

  const increaseAmount = (id) => {
    const cartItem = cart.find((item) => item.id === id);
    addToCart(cartItem, id);
  };

  const decreaseAmount = (id) => {
    const cartItem = cart.find((item) => item.id === id);
    if (cartItem) {
      const newCart = cart.map((item) => {
        if (item.id === id) {
          return { ...item, amount: cartItem.amount - 1 };
        } else {
          return item;
        }
      });
      setCart(newCart);
    }
    if (cartItem.amount < 2) {
      removeFromCart(id);
    }
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        removeFromCart,
        clearCart,
        increaseAmount,
        decreaseAmount,
        itemAmount,
        total,
        taxRate,
        setTaxRate,
        shippingCost,
        setShippingCost,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export default CartProvider;
